import './App.css';
import { Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import { LanguageProvider } from './contexts/LanguageContext';
import { ContentProvider } from './contexts/ContentContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Aboutus from './components/Aboutus';
import ExploreServices from './components/ExploreServices';
import Portfolio from './components/Portfolio';
import Steps from './components/Steps';
import WhyChooseUs from './components/WhyChooseUs';
import ContactSection from './components/Contact';
import FooterSection from './components/Footer';
import ContactIcon from './components/ContactIcon';
import ServiceDetail from './pages/ServiceDetail';
import WhyChooseUsPage from './pages/WhyChooseUsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import OrganizationalStructurePage from './pages/OrganizationalStructurePage';
import Dashboard from './pages/Dashboard';

function App() {


  return (
    <ContentProvider>
      <LanguageProvider>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Navbar />
                <Hero />
                <Aboutus />
                <ExploreServices />
                <Portfolio />
                <Steps />
                <WhyChooseUs />
                <FooterSection />
                <ContactIcon />
              </>
            } />
            <Route path="/service/:id" element={<ServiceDetail />} />
            <Route path="/why-choose-us" element={<WhyChooseUsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/organizational-structure" element={<OrganizationalStructurePage />} />
            
            {/* Dashboard Routes */}
            <Route path="/dashboard/*" element={<Dashboard />} />
          </Routes>
        </div>
      </LanguageProvider>
    </ContentProvider>
  );
}


export default App;
